import { create } from '@bufbuild/protobuf'

import { Contract } from '@enechain/eposition-proto/bffcommon/v1/eex_model_pb'
import {
  OrderSimulationRelationWithNumber,
  OrderSimulationRelationWithNumberSchema,
} from '@enechain/eposition-proto/devtool/v1/service_pb'

import { SimulationOrderPatternModel } from '~/pages/Simulation/models/SimulationOrderPattern'
import { convertToSimulationOrderPatternModels } from '~/pages/Simulation/models/SimulationOrderPatterns'
import { OrderSimulationSchema } from '~/pages/Simulation/schemas'

export type AvailableDealSimulationRelationModel = {
  simulationRelations: OrderSimulationRelationWithNumber[]
  orderPatterns: SimulationOrderPatternModel[]
}

export const AVAILABLE_DEAL_SIMULATION_MAX_SIZE = 3

function generateSubsetsRecursive(
  arr: number[],
): OrderSimulationRelationWithNumber[] {
  const result: OrderSimulationRelationWithNumber[] = []
  for (
    let size = 1;
    size <= Math.min(arr.length, AVAILABLE_DEAL_SIMULATION_MAX_SIZE);
    size++
  ) {
    generateSubsetsOfSize(arr, size, 0, [], result)
  }
  return result
}

function generateSubsetsOfSize(
  arr: number[],
  targetSize: number,
  start: number,
  current: number[],
  result: OrderSimulationRelationWithNumber[],
): void {
  if (current.length === targetSize) {
    result.push(
      create(OrderSimulationRelationWithNumberSchema, {
        relationNumber: result.length + 1,
        orderNumbers: [...current],
      }),
    )
    return
  }

  const remaining = arr.length - start
  const needed = targetSize - current.length
  if (remaining < needed) {
    return
  }

  for (let i = start; i < arr.length; i++) {
    current.push(arr[i])
    generateSubsetsOfSize(arr, targetSize, i + 1, current, result)
    current.pop()
  }
}

export function convertToAvailableDealSimulationRelationModels(
  orderSimulation: OrderSimulationSchema,
  eexContracts: Contract[] = [],
): { models?: AvailableDealSimulationRelationModel; error?: string } {
  const { orderPatternModels, error } = convertToSimulationOrderPatternModels(
    orderSimulation,
    'DEAL_AVAILABLE',
    eexContracts,
  )
  if (error !== undefined) {
    return { error }
  }

  const models: AvailableDealSimulationRelationModel = {
    simulationRelations: generateSubsetsRecursive(
      orderSimulation.availableDealSimulationRelation,
    ),
    orderPatterns: orderPatternModels?.models ?? [],
  }
  return { models }
}
